import React, { Component } from 'react';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Button from "@material-ui/core/Button";
import mailIcon from '../mail-icon.svg';
import { styles as globalStyles, variables } from "../styles";
import { withStyles } from "@material-ui/core";
import {requestPubnubApiPOST, withCredentials} from "../apiClient";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";;

const styles = {
  ...globalStyles,
  root: {
    maxWidth: '500px',
    marginLeft: 'auto',
    marginRight: 'auto',

    '& h4': {
      fontSize: '24px',
      fontWeight: 'bold',
      fontFamily: 'Proxima Nova',
    },
  },
  logo: {
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  goBackWrapper: {
    textAlign: 'right',
  },
  goBack: {
    cursor: 'pointer',
    color: variables.RED_CARDINAL,
    lineHeight: 2.2,
    fontSize: '15px',
    '& > svg': {
      position: 'relative',
      height: '15px',
      width: '15px',
      top: '2px',
    },
  },
  icon: {
    width: '100px',
    height: '76px',
    backgroundSize: 'auto',
  },
  email: {
    fontWeight: 'bold',
    fontFamily: 'proxima_nova_altbold'
  },
  logoWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  btn: {
    textTransform: 'none',
    width: '100%',
    padding: '15px 10px',
    fontSize: '17px',
    fontFamily: 'Proxima Nova',
    ...globalStyles.button,
    color: 'white',
    marginTop: '10px',
  },
  typography: {
    ...globalStyles.typography,
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  marginTop: {
    marginTop: '10px'
  }
}

class ConfirmEmail extends Component {
  state = {
    isRequesting: false,
    interval: undefined,
  }

  componentDidMount() {
    const interval = setInterval(async () => {
      await this.checkUserStatus()
    }, 5000)

    this.setState({interval})
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  checkUserStatus = async () => {
    try {
      await this.props.tryToLogin();
      if (this.props.loggedIn) {
        this.props.history.push('/activate-pubsub')
      }
    } catch (e) {}
  }

  onResend = async () => {
    this.setState({isRequesting: true})
    await withCredentials(requestPubnubApiPOST)(
      '/users/confirmation-email',
      {
        body: {
          'email': this.props.email
        }
      }
    );
    this.setState({ isRequesting: false })
  }

  render() {
    const { classes, email } = this.props;
    const { isRequesting } = this.state;

    return (
      <Grid
        container
        className={classes.root}
        spacing={16}
      >
        <Grid item xs={12} className={classes.logoWrapper}>
          <img alt="PubNub" src="pubnub.png" style={{width: "100px"}}/>
        </Grid>
        <Grid item xs={8}>
          <Typography variant="h4" className={classes.title}>Please check your inbox</Typography>
        </Grid>
        <Grid item xs={4} className={classes.goBackWrapper}>
        <span className={classes.goBack} onClick={() => window.history.back()}>
          Go Back <ArrowForwardIcon height={15} width={15} />
        </span>
        </Grid>
        <Grid item xs={4}>
          <img src={mailIcon} className={classes.icon} alt="ico"/>
        </Grid>
        <Grid item xs={8}>
          <Typography className={classes.typography}>
            We’re happy to welcome you to PubNub. You’re almost there!
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.typography}>
            We sent an email to <span id="confirm-email__email" className={classes.email}>{email}</span>{' '}
            containing a confirmation link. To continue, please check your email
            and verify your account.
          </Typography>
          <Typography className={`${classes.typography} ${classes.marginTop}`}>
            If you didn’t receive it, please click the button below to send a new
            one.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            className={classes.btn}
            onClick={this.onResend}
          >
            {
              isRequesting ?
                <CircularProgress id="spinner" size={21} className={this.props.classes.buttonCircularProgress}/>
                : 'Send new confirmation link'
            }
          </Button>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(ConfirmEmail);


// WEBPACK FOOTER //
// ./src/componentes/ConfirmEmail.js